import { useTranslation } from 'react-i18next'

import { PageBody } from '~/components/common/PageBody'
import { PageLayout } from '~/components/common/PageLayout'
import { PageScrollArea } from '~/components/common/PageScrollArea'
import { PersonalSettingsForm } from '~/pages/Settings/components/PersonalSettingsForm'

export const SettingsPage = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <PageLayout
      breadcrumbItems={[{ label: t('common:route.settings'), bold: true }]}
    >
      <PageBody>
        <PageScrollArea>
          {/* design HTML の `.content--center { max-width: 960px; margin: 16px auto; }` 相当。
              design/css/layout.css line 969 参照。 スクロール所有は PageScrollArea に移管
              したため、この div は上下の余白 (padding) のみを担う。 */}
          <div style={{ padding: '16px 0' }}>
            <div style={{ maxWidth: 960, margin: '0 auto' }}>
              <PersonalSettingsForm />
            </div>
          </div>
        </PageScrollArea>
      </PageBody>
    </PageLayout>
  )
}
